import BaseDialog from "@/components/BaseDialog";
import BaseDrawer from "@/components/BaseDrawer";
// oppo批量创建

// 核实计划信息
export function planModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./planModal.vue'),
        options: {
            width: '800px',
            title: '核实计划信息',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

//不支持计划 检查
export function errorPlanModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./errorPlanModal.vue'),
        options: {
            width: '600px',
            title: '温馨提示',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 温馨提示
export function errorModal({ props, cbs, on }) {
    return new BaseDialog({
        component: ()=>import('./errorModal.vue'),
        options: {
            width: '600px',
            title: '温馨提示',
            closeOnPressEscape:false,
            closeOnClickModal:false,
            showClose: false
        },
        on,
        props,
        cbs,
    })
}




// 批量录入
export function batchEnterModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./batchEnterModal'),
        options: {
            width: '600px',
            title: '批量录入产品',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs
    })
}
/**
 * 素材 自动匹配上传
 * @param {*} param0
 * @returns
 */
export function autoMatchOrder({ props, cbs }) {
  return new BaseDrawer({
    component: ()=>import('./autoMatchOrder'),
    options: {
      size: '1200px',
      title: '自动匹配上传',
      'close-on-press-escape': false,
      wrapperClosable: false,
      'show-close': false,
      'custom-class': 'mi-drawer-create'
    },
    props,
    cbs
  })
}

/**
 * 应用选择
 * @param {*} param0
 * @returns
 */
export function selectSizeModal({ props, cbs, on }) {
  return new BaseDialog({
    component: ()=>import('./selectSizeModal'),
    options: {
      width: '600px',
      title: '存在重复尺寸',
      closeOnPressEscape:false,
      closeOnClickModal:false,
    },
    on,
    props,
    cbs
  })
}

export function tipModal({ props, title='提示' ,cbs }) {
  return new BaseDialog({
    component: ()=>import('@/views/marketingManagement/mi/modal/tipModal'),
    options: {
      width: '500px',
      title,
      'close-on-press-escape': false,
      'show-close': false,
      'close-on-click-modal': false
    },
    props,
    cbs,
    on: {}
  })
}

// 被复制账户&计划详情弹框
export function copyPlanInfoModal({ props, cbs, on }) {
  return new BaseDialog({
    component: ()=>import('./copyPlanInfoModal'),
    options: {
      width: '600px',
      title: '被复制账户&计划详情',
      closeOnPressEscape:false,
      closeOnClickModal:false,
    },
    on,
    props,
    cbs
  })
}
